define('helperMisc-cloneObject',[],function() {
    'use strict';

    var cloneObject = function(obj) {
        var i,
            target = {};

        for (i in obj) {
            if (obj.hasOwnProperty(i)) {
                target[i] = obj[i];
            }
        }

        return target;
    };

    return cloneObject;
});

